import type { DefinicionTour } from '@/shared/tour';
import { crearAyudaPasoTemporal } from '@/shared/tour/contenidoAyudaTemporal';

export const tourNuevoProducto: DefinicionTour = {
  id: 'producto_modal',
  version: 1,
  pasos: [
    {
      idPaso: 'producto-datos-basicos',
      selector: '[data-tour="producto-tipo"]',
      selectorExpandido: '[data-tour="producto-identificacion"]',
      titulo: 'Completa los datos del producto',
      descripcion:
        'Selecciona si es un bien o servicio, coloca su nombre y agrega los códigos que lo identifican.',
      posicion: 'derecha',
      ...crearAyudaPasoTemporal({
        contenidoLectura: [
          'Elige si es un Bien o un Servicio, según lo que ofrezcas.',
          'Ingresa el nombre del producto, tal como aparecerá en tus comprobantes.',
          'Agrega un código para identificarlo y, si corresponde, su código de barras.',
        ],
      }),
    },
    {
      idPaso: 'producto-precio',
      selector: '[data-tour="producto-precio"]',
      titulo: 'Precio y disponibilidad',
      descripcion: 'Define cuánto cuesta y en qué establecimientos se vende.',
      posicion: 'derecha',
      ...crearAyudaPasoTemporal({
        contenidoLectura: [
          'Ingresa el precio de venta y el impuesto que le corresponde.',
          'Si manejas más de un establecimiento, elige en cuáles estará disponible.',
        ],
      }),
    },
    {
      idPaso: 'producto-unidad',
      selector: '[data-tour="producto-unidad"]',
      selectorExpandido: '[data-tour="producto-clasificacion"]',
      titulo: 'Define cómo venderás tu producto',
      descripcion: 'Selecciona el tipo de medida y la unidad con la que venderás tu producto. Luego, elige la categoría donde quieres organizarlo.',
      posicion: 'derecha',
      ...crearAyudaPasoTemporal({
        contenidoLectura: [
          'Elige la familia de unidad, que agrupa el tipo de medida. Por ejemplo: unidades, peso o volumen.',
          'Selecciona la unidad mínima con la que venderás tu producto. Por ejemplo: unidad, kilogramo o litro.',
          'Asígnale una categoría para organizarlo dentro de tu catálogo.',
        ],
      }),
    },
    {
      idPaso: 'producto-imagen',
      selector: '[data-tour="producto-imagen"]',
      titulo: 'Imagen del producto',
      descripcion: 'Sube una imagen para identificarlo más rápido en tus listas y comprobantes.',
      posicion: 'izquierda',
      ...crearAyudaPasoTemporal({
        contenidoLectura: [
          'Es opcional, pero ayuda a reconocer el producto de un vistazo.',
          'Puedes agregarla ahora o después, editando el producto.',
          'Si necesitas más datos (marca, modelo, descuento, información tributaria), actívalos desde "+ Más campos".',
        ],
      }),
    },
  ],
};
